import React, { useEffect, useState } from "react";
import { Button, Row, Col, Spinner } from "react-bootstrap";
import {
  useGetFarmersQuery,
  useMultipleReportDownloadMutation,
} from "./farmerApiSlice";
import { DataGrid } from "@mui/x-data-grid";
import StateDistrict from "./StateDistrict";
import CustomSearchBar from "components/CustomSearchBar";
import Pagination from "@mui/material/Pagination";
import { toast } from "react-toastify";
import { API_URL } from "app/config";
import { store } from "app/store";
import { Table } from "reactstrap";
import { useSelector } from "react-redux";
import { selectCurrentUser } from "features/auth/authSlice";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRotateLeft } from "@fortawesome/free-solid-svg-icons";
import { useLocation } from "react-router-dom";

export const FarmerTemplateDownload = ({ setAssignOption, orgId }) => {
  const { pathname } = useLocation();

  const hasProject = pathname.includes("project");

  const [selectedFarmerIds, setSelectedFarmerIds] = useState([]);
  const [state_id, setStateId] = useState("");
  const [district_id, setDistrictId] = useState("");
  const [block_id, setBlockId] = useState("");
  const [stateName, setStateName] = useState("");
  const [districtName, setDistrictName] = useState("");
  const [blockName, setBlockName] = useState("");
  const [blockList, setBlockList] = useState([]);
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [searchKey, setSearchKey] = useState("");
  const [farmerRows, setfarmerRows] = useState([]);
  const [multipleDownloadFarmers] = useMultipleReportDownloadMutation();
  const [plots, setPlots] = useState("");
  const [type, setType] = useState("");
  const [pagination, setPagination] = useState({
    page: 1,
    pageCount: 0,
    per_page: 50,
  });

  const { data: farmerData, isLoading: farmerLoading } = useGetFarmersQuery(
    {
      page: pagination.page,
      per_page: pagination.per_page,
      orgId,
      stateId: state_id,
      districtId: district_id,
      searchKey: debouncedSearch || "",
    },
    { refetchOnMountOrArgChange: true },
  );
  const [showDownloads, setShowDownloads] = useState(false);
  const [reportingData, setReportingData] = useState([]);
  const currentUser = useSelector(selectCurrentUser);
  const[refetchLoading,setRefetchLoading] = useState(false);
  const RoleAcessParamsOrgId = currentUser?.organization_id;
  // const isAdmin =currentUser?.groups?.includes("admin")?true:false;
  useEffect(() => {
    const paginationFromApi = farmerData?.data?.pages
      ? {
          page: farmerData?.data?.current_page,
          pageCount: farmerData?.data?.pages,
          per_page: farmerData?.data?.per_page,
        }
      : pagination;
    setPagination(paginationFromApi);
    setfarmerRows(farmerData?.data?.results ? farmerData?.data?.results : []);
  }, [farmerData]);

  const columns = [
    { field: "full_name", headerName: "Name", width: 150 },
    {
      field: "created_at",
      headerName: "Onboarding Date",
      width: 150,
      renderCell: (cellvalues) => cellvalues.row.created_at?.slice(0, 10) || "",
    },
    { field: "phone_number", headerName: "Mobile", width: 120 },
    { field: "gender", headerName: "Gender", width: 80 },
    { field: "age", headerName: "Age", width: 50 },
    {
      field: "farmer_category",
      headerName: "Category",
      width: 200,
      renderCell: ({ row }) => (
        <div style={{ fontSize: "14px" }} title={row.farmer_category}>
          {(row.farmer_category || "").length > 50
            ? `${row.farmer_category.substring(0, 50)}...`
            : row.farmer_category}
        </div>
      ),
    },
    {
      field: "total_land_holding",
      headerName: "Declared Landholding",
      width: 110,
      renderCell: ({ row }) =>
        `${row.total_land_holding} ${row.unit_of_land_holding || ""}`,
    },
    {
      field: "total_acs",
      headerName: "ACS",
      width: 100,
      renderCell: ({ row }) => row.total_acs?.toFixed(2),
    },
    { field: "state_name", headerName: "State Name", width: 130 },
    {
      field: "district_name",
      headerName: "District Name",
      width: 140,
      renderCell: ({ row }) => (
        <div style={{ fontSize: "13px" }} title={row.district_name}>
          {(row.district_name || "").length > 50
            ? `${row.district_name.substring(0, 50)}...`
            : row.district_name}
        </div>
      ),
    },
  ];

  const onLocationChange = (event) => {
    if (event.ConditionName === "state") {
      setBlockId("");
      setDistrictName("");
      setDistrictId("");
      setBlockName("");
      setBlockList([]);
      setStateId(event.value);
      setStateName(event.label);
    }
    if (event.ConditionName === "district") {
      setDistrictId(event.value);
      setDistrictName(event.label);
      setBlockId("");
      setBlockName("");
    }
    if (event.ConditionName === "block") {
      setBlockId(event.value);
      setBlockName(event.label);
    }
    setPagination({ page: 1, pageCount: 0, per_page: 50 });
  };

  const reportBulkData = async () => {
    const responseData = {
      template_type: type ? type : "complete",
      organisation_id: orgId ? orgId : RoleAcessParamsOrgId,
      farmer_detail: selectedFarmerIds?.map((f) => ({
        farmer_id: f,
        no_of_plots: plots ? plots : 1,
      })),
    };

    multipleDownloadFarmers(responseData)
      .unwrap()
      .then((data) => {
        toast.success("Task Created");
      })
      .catch((error) => {
        toast.error("Error while Uploading Farmer");
        return;
      });
  };
  //   const reportBulkData = async () => {
  //   const responseData = {
  //     template_type: type || "complete",
  //     organisation_id: orgId,
  //     farmer_detail: selectedFarmerIds?.map((f) => ({
  //       farmer_id: f,
  //       no_of_plots: plots || 1,
  //     })),
  //   };

  //   const url = "https://vaaradhi-dev.agrani.tech/reporting/api/acs/multi-report";

  //   try {
  //     const response = await fetch(url, {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json",
  //         "Authorization": "Bearer eyJhbGciOiJSUzI1NiIsInR5cCIgOiAiSldUIiwia2lkIiA6ICJBY1cwSW16UGd1MWpnb2RzYm40LVYybC1LLVFPUGE5T0ZxbS1QcWVLLVhFIn0.eyJleHAiOjE3NjY2NjQ4MjcsImlhdCI6MTc2NjA2MDAyNywiYXV0aF90aW1lIjoxNzY2MDYwMDI2LCJqdGkiOiIyNTg3NTM4Zi0yN2VhLTRlNTQtOGE3YS1kYmZjYWI4MzRmNWIiLCJpc3MiOiJodHRwczovL2F1dGgtZGV2LmFncmFuaS50ZWNoL3JlYWxtcy9hZ3JhbmkiLCJhdWQiOiJhY2NvdW50Iiwic3ViIjoiNGE2YmQ2ZWUtYzQ4OS00NDJkLWEzZWQtNzk1Njg4MmFhZTU4IiwidHlwIjoiQmVhcmVyIiwiYXpwIjoiYWdyYW5pLXdlYnNpdGUiLCJzaWQiOiJjYjA4ZjlmZC1kYmUwLTQ5MmItYmY1MC1mMGUzMWVmMzVkZGIiLCJhY3IiOiIxIiwiYWxsb3dlZC1vcmlnaW5zIjpbIioiXSwicmVhbG1fYWNjZXNzIjp7InJvbGVzIjpbImFncmFuaSIsIm9mZmxpbmVfYWNjZXNzIiwiYWRtaW4iLCJkZXZlbG9wZXIiLCJkZWZhdWx0LXJvbGVzLWFncmFuaSIsInVtYV9hdXRob3JpemF0aW9uIl19LCJyZXNvdXJjZV9hY2Nlc3MiOnsiYWNjb3VudCI6eyJyb2xlcyI6WyJtYW5hZ2UtYWNjb3VudCIsIm1hbmFnZS1hY2NvdW50LWxpbmtzIiwidmlldy1wcm9maWxlIl19fSwic2NvcGUiOiJvcGVuaWQgcHJvZmlsZSBlbWFpbCIsImFzc2lnbmVkX2RvbWFpbnMiOlsiQmFua2luZyJdLCJlbWFpbF92ZXJpZmllZCI6dHJ1ZSwicHJvZmlsZSI6Imh0dHBzOi8vYWdyYW5pLW1lZGlhLnMzLmFwLXNvdXRoLTEuYW1hem9uYXdzLmNvbS9hZ3JhbmlfYmFja2VuZF92Mi9wdWJsaWMvaW1hZ2VzL2RlZmF1bHRfcHJvZmlsZS5wbmciLCJncm91cHMiOlsiYWRtaW4iXSwicHJlZmVycmVkX3VzZXJuYW1lIjoiOTEzMzQzNTU0MyIsIm9yZ2FuaXphdGlvbl9uYW1lIjoiTGVhZHMgQ29ubmVjdCIsImdpdmVuX25hbWUiOiJDaGFyYW4iLCJhc3NpZ25lZF96b25lX2NvZGVzIjpbIjkiXSwib3JnYW5pemF0aW9uX2NvZGUiOiIzMTM3ODUyODk5MTQiLCJlbXBsb3llZV9jb2RlIjoiREVWMDAxIiwib3JnYW5pemF0aW9uX2NhdGVnb3J5IjoibGVhZHNjb25uZWN0Iiwib3JnYW5pemF0aW9uX2lkIjoiOGZkZWIwZmYtNjIzMC00NTE3LThhNzEtODdlNjY0MDE2Y2M2IiwibmFtZSI6IkNoYXJhbiBLdW1hciIsIm9yZ2FuaXphdGlvbl90eXBlIjoiYWdyYW5pIiwiYXNzaWduZWRfem9uZSI6IlN0YXRlIiwiZmFtaWx5X25hbWUiOiJLdW1hciIsImVtYWlsIjoiY2hhcmFuLmt1bWFyQGxlYWRzY29ubmVjdC5pbiJ9.ddhcmYLDzMUddcl6JdnxHcBZGdwTSaoMD7FkWu3vBwBEqdhpPud9OgaFRXT1_Oy5k5lQW2lvXQY3HUSm-wAVm3yKvw4UUp4wAw0RIn1aRCXadSDdRs8OhlLyAA_rNVlgIgk3eOu0sqtqgfgeFY-nBHF_XWYWY8O2moN8NpzDh4EFf2G9lTYNH8WOucBRsMrWN7iFwGhqECHH40xG-k754TBr5FiViHz8XsSiF7IUchY28_Jpwo8YKYVPYqgiEl46scgqD-kbEDxCLB89MaRWNwssYF1FwyHIgc6zsQq0JKY1DjN45D6hWfuyYXzZD6UkCSrgiCtBQiSHOPDEFqQatA",
  //       },
  //       body: JSON.stringify(responseData),
  //     });

  //     if (!response.ok) {
  //       throw new Error(`Error: ${response.status}`);
  //     }

  //     const data = await response.json();
  //     console.log("API Response:", data);
  //     toast.success("Task Created Successfully");
  //   } catch (error) {
  //     console.error(error);
  //     toast.error("Error while creating report task");
  //   }
  // };

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(searchKey.trim() ? searchKey : "");
    }, 500);
    return () => clearTimeout(handler);
  }, [searchKey]);

  const handleChangeSearch = (value) => {
    setSearchKey(value);
    setPagination({ page: 1, pageCount: 0, per_page: 50 });
  };

  const filterDataBasedId = (item) => {
    setSelectedFarmerIds(item);
  };
  const CustomPagination = () => {
    return (
      <Pagination
        color="primary"
        count={pagination?.pageCount}
        page={pagination?.page}
        onChange={(event, value) => {
          setPagination({
            page: value,
            pageCount: pagination?.pageCount,
            perPage: pagination.perPage,
          });
        }}
        variant="outlined"
        shape="rounded"
      />
    );
  };
  const formatDateTime = (dateString) => {
    if (!dateString) return "";

    let date;

    if (dateString.includes("T")) {
      date = new Date(dateString);
    }

    else {
      const [datePart, timePart] = dateString.split(" ");
      const parts = datePart?.split("/");

      if (parts?.length === 3) {
        const [day, month, year] = parts;

        const time = timePart ? `${timePart}:00` : "00:00:00";

        date = new Date(`${year}-${month}-${day}T${time}`);
      }
    }

    if (!date || isNaN(date.getTime())) return "";

    const day = date.getDate();
    const month = date.toLocaleString("en-IN", { month: "long" });
    const year = date.getFullYear();

    const time = date
      .toLocaleTimeString("en-IN", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      })
      .replace(" ", "")
      .toUpperCase();

    return `${day} ${month} ${year} , ${time}`;
  };
  const fetchDashboard = async () => {
    setRefetchLoading(true)
    try {
      const state = store.getState();
      const url = `${API_URL}/reporting/api/acs/reports/?organisation_id=${
        hasProject ? orgId || RoleAcessParamsOrgId : ""
      }`;
      // const url = `https://vaaradhi-dev.agrani.tech/reporting/api/acs/reports/`;

      const response = await fetch(url, {
        headers: { authorization: `Bearer ${state.auth.accessToken}` },
        // headers:{authorization : `Bearer eyJhbGciOiJSUzI1NiIsInR5cCIgOiAiSldUIiwia2lkIiA6ICJBY1cwSW16UGd1MWpnb2RzYm40LVYybC1LLVFPUGE5T0ZxbS1QcWVLLVhFIn0.eyJleHAiOjE3NjY2NjQ4MjcsImlhdCI6MTc2NjA2MDAyNywiYXV0aF90aW1lIjoxNzY2MDYwMDI2LCJqdGkiOiIyNTg3NTM4Zi0yN2VhLTRlNTQtOGE3YS1kYmZjYWI4MzRmNWIiLCJpc3MiOiJodHRwczovL2F1dGgtZGV2LmFncmFuaS50ZWNoL3JlYWxtcy9hZ3JhbmkiLCJhdWQiOiJhY2NvdW50Iiwic3ViIjoiNGE2YmQ2ZWUtYzQ4OS00NDJkLWEzZWQtNzk1Njg4MmFhZTU4IiwidHlwIjoiQmVhcmVyIiwiYXpwIjoiYWdyYW5pLXdlYnNpdGUiLCJzaWQiOiJjYjA4ZjlmZC1kYmUwLTQ5MmItYmY1MC1mMGUzMWVmMzVkZGIiLCJhY3IiOiIxIiwiYWxsb3dlZC1vcmlnaW5zIjpbIioiXSwicmVhbG1fYWNjZXNzIjp7InJvbGVzIjpbImFncmFuaSIsIm9mZmxpbmVfYWNjZXNzIiwiYWRtaW4iLCJkZXZlbG9wZXIiLCJkZWZhdWx0LXJvbGVzLWFncmFuaSIsInVtYV9hdXRob3JpemF0aW9uIl19LCJyZXNvdXJjZV9hY2Nlc3MiOnsiYWNjb3VudCI6eyJyb2xlcyI6WyJtYW5hZ2UtYWNjb3VudCIsIm1hbmFnZS1hY2NvdW50LWxpbmtzIiwidmlldy1wcm9maWxlIl19fSwic2NvcGUiOiJvcGVuaWQgcHJvZmlsZSBlbWFpbCIsImFzc2lnbmVkX2RvbWFpbnMiOlsiQmFua2luZyJdLCJlbWFpbF92ZXJpZmllZCI6dHJ1ZSwicHJvZmlsZSI6Imh0dHBzOi8vYWdyYW5pLW1lZGlhLnMzLmFwLXNvdXRoLTEuYW1hem9uYXdzLmNvbS9hZ3JhbmlfYmFja2VuZF92Mi9wdWJsaWMvaW1hZ2VzL2RlZmF1bHRfcHJvZmlsZS5wbmciLCJncm91cHMiOlsiYWRtaW4iXSwicHJlZmVycmVkX3VzZXJuYW1lIjoiOTEzMzQzNTU0MyIsIm9yZ2FuaXphdGlvbl9uYW1lIjoiTGVhZHMgQ29ubmVjdCIsImdpdmVuX25hbWUiOiJDaGFyYW4iLCJhc3NpZ25lZF96b25lX2NvZGVzIjpbIjkiXSwib3JnYW5pemF0aW9uX2NvZGUiOiIzMTM3ODUyODk5MTQiLCJlbXBsb3llZV9jb2RlIjoiREVWMDAxIiwib3JnYW5pemF0aW9uX2NhdGVnb3J5IjoibGVhZHNjb25uZWN0Iiwib3JnYW5pemF0aW9uX2lkIjoiOGZkZWIwZmYtNjIzMC00NTE3LThhNzEtODdlNjY0MDE2Y2M2IiwibmFtZSI6IkNoYXJhbiBLdW1hciIsIm9yZ2FuaXphdGlvbl90eXBlIjoiYWdyYW5pIiwiYXNzaWduZWRfem9uZSI6IlN0YXRlIiwiZmFtaWx5X25hbWUiOiJLdW1hciIsImVtYWlsIjoiY2hhcmFuLmt1bWFyQGxlYWRzY29ubmVjdC5pbiJ9.ddhcmYLDzMUddcl6JdnxHcBZGdwTSaoMD7FkWu3vBwBEqdhpPud9OgaFRXT1_Oy5k5lQW2lvXQY3HUSm-wAVm3yKvw4UUp4wAw0RIn1aRCXadSDdRs8OhlLyAA_rNVlgIgk3eOu0sqtqgfgeFY-nBHF_XWYWY8O2moN8NpzDh4EFf2G9lTYNH8WOucBRsMrWN7iFwGhqECHH40xG-k754TBr5FiViHz8XsSiF7IUchY28_Jpwo8YKYVPYqgiEl46scgqD-kbEDxCLB89MaRWNwssYF1FwyHIgc6zsQq0JKY1DjN45D6hWfuyYXzZD6UkCSrgiCtBQiSHOPDEFqQatA`}
      });
      if (!response.ok) throw new Error("Network response was not ok");
      const data = await response.json();
      setReportingData(data?.data);
       setRefetchLoading(false)

    } catch (error) {
      console.error("Fetch error:", error);
      setRefetchLoading(false)
    }
  };
  useEffect(() => {
    if (showDownloads) {
      fetchDashboard();
    }
  }, [showDownloads]);
  const handleDownload = (fileUrl) => {
    if (!fileUrl) return;

    const link = document.createElement("a");
    link.href = fileUrl;
    link.setAttribute("download", "");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  const calculateDuration = (start, end) => {
    if (!start || !end) return "-";

    const startTime = new Date(start);
    const endTime = new Date(end);

    if (isNaN(startTime) || isNaN(endTime)) return "-";

    const diffMs = endTime - startTime;

    const minutes = Math.floor(diffMs / 60000);
    const seconds = Math.floor((diffMs % 60000) / 1000);

    return `${minutes}m ${seconds}s`;
  };

  return (
    <div className="container mt-4">
      <div className="d-flex justify-content-center gap-2 mb-3">
        <Button
          size="sm"
          variant={showDownloads ? "outline-warning" : "warning"}
          onClick={() => setShowDownloads(false)}
        >
          Download Report
        </Button>

        <Button
          size="sm"
          variant={showDownloads ? "warning" : "outline-warning"}
          onClick={() => setShowDownloads(true)}
        >
          Downloads
        </Button>
      </div>

      {!showDownloads ? (
        <>
          <Row style={{ backgroundColor: "#f8f8f8" }}>
            <Col md={2} className="mt-3">
              <CustomSearchBar sendSearchFunction={handleChangeSearch} />
            </Col>
            <Col md={10}>
              <StateDistrict
                onLocationChange={onLocationChange}
                state_id={state_id}
                district_id={district_id}
                block_id={block_id}
                stateName={stateName}
                districtName={districtName}
                blockName={blockName}
                setBlockList={setBlockList}
                blockList={blockList}
                noBlock={true}
                setStateName={setStateName}
                setDistrictName={setDistrictName}
                setStateId={setStateId}
                setDistrictId={setDistrictId}
              />
            </Col>
          </Row>

          <div className="d-flex justify-content-between align-items-center my-3">
            <h5 className="mb-0">Select Farmers</h5>
            <div className="d-flex gap-2">
              <select
                className="form-select form-select-sm"
                style={{ minWidth: "120px" }}
                value={plots}
                onChange={(e) => setPlots(e.target.value)}
              >
                <option value="">Plots</option>
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
              </select>

              <select
                className="form-select form-select-sm"
                style={{ minWidth: "150px" }}
                value={type}
                onChange={(e) => setType(e.target.value)}
              >
                <option value="">Type</option>
                <option value="complete">Complete</option>
                <option value="historical">Historical</option>
                <option value="current">Current</option>
              </select>
              <Button variant="success" size="sm" onClick={reportBulkData}>
                Submit
              </Button>
            </div>
          </div>

          {farmerLoading ? (
            <div className="d-flex flex-column justify-content-center align-items-center py-5">
              <Spinner
                animation="border"
                variant="primary"
                role="status"
                style={{ width: "2rem", height: "2rem" }}
              >
                <span className="visually-hidden">Loading...</span>
              </Spinner>
              <div className="mt-3">
                <strong>Loading farmer data...</strong>
              </div>
            </div>
          ) : (
            <DataGrid
              rows={farmerRows}
              columns={columns}
              rowsPerPageOptions={[3]}
              checkboxSelection
              keepNonExistentRowsSelected
              onRowSelectionModelChange={(item) => {
                filterDataBasedId(item);
              }}
              components={{
                Pagination: CustomPagination,
              }}
            />
          )}
        </>
      ) : (
        <div>
          <Button
            className="bg-transparent text-black float-end"
            style={{
              border: "1px solid #829999",
              color: "#343737",
              marginTop: "0",
            }}
            size="sm"
            onClick={() => fetchDashboard()}
          >
            <FontAwesomeIcon icon={faRotateLeft} />
            &nbsp;{refetchLoading && <span>Loading...<Spinner size="sm"/></span>}
          </Button>
          
          {reportingData?.length > 0 ? (
            <Table striped hover>
              <thead>
                  <tr>
                    <th className="th-sm">Report Type</th>
                    <th className="th-sm">Status</th>
                    <th className="th-sm">Started At</th>
                    <th className="th-sm">Finished At</th>
                    <th className="th-sm">Duration</th>
                    <th className="th-sm">File</th>
                  </tr>
              </thead>
              <tbody>
                {/* {reportingData?.map((field, index) => (
                <tr key={index}>
                  <td>{field.template_type}</td>

                  <td className="">
                    <span
                      className={`badge ${
                        field.status === "uploaded"
                          ? "bg-success-subtle text-success"
                          : "bg-warning-subtle text-warning"
                      } px-3 py-2`}
                    >
                      {field.status?.toUpperCase()}
                    </span>
                  </td>

                  <td>{formatDateTime(field.date_created)}</td>

                  <td>{formatDateTime(field.timestamp)}</td>

                  <td className="">
                    {field.status === "uploaded" ? (
                      <Button
                        size="sm"
                        className="text-warning"
                        onClick={() => handleDownload(field.file_url)}
                      >
                        <i
                          className="mdi mdi-download"
                          style={{ color: "white" }}
                        ></i>
                      </Button>
                    ) : (
                      <span className="mx-2">- </span>
                    )}
                  </td>
                </tr>
              ))} */}
                  {reportingData?.map((field, index) => (
                    <tr key={index}>
                      <td>{field.template_type}</td>

                      <td>
                        <span
                          className={`badge ${
                            field.status === "uploaded"
                              ? "bg-success-subtle text-success"
                              : "bg-warning-subtle text-warning"
                          } px-3 py-2`}
                        >
                          {field.status?.toUpperCase()}
                        </span>
                      </td>

                      <td>{formatDateTime(field.date_created)}</td>

                      <td>
                        {field.status === "uploaded"
                          ? formatDateTime(field.timestamp)
                          : "-"}
                      </td>

                      <td>
                        {field.status === "uploaded"
                          ? calculateDuration(
                              field.date_created,
                              field.timestamp,
                            )
                          : "In Progress"}
                      </td>

                      <td>
                        {field.status === "uploaded" ? (
                          <Button
                            size="sm"
                            className="text-warning"
                            onClick={() => handleDownload(field.file_url)}
                          >
                            <i
                              className="mdi mdi-download"
                              style={{ color: "white" }}
                            />
                          </Button>
                        ) : (
                          <span>-</span>
                        )}
                      </td>
                    </tr>
                  ))}
              </tbody>
            </Table>
          ) : (
            <div className="text-center mb-5 " style={{ marginTop: "40px" }}>
              No Data Available
            </div>
          )}
        </div>
      )}
    </div>
  );
};
